"use client";

import * as React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";

export function ConfirmDialog(props: any) {
  return (
    <>
      <Dialog.Root open={props?.open} onOpenChange={props?.setOpen}>
        <Dialog.Portal>
          {/* Overlay */}
          <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />

          {/* Dialog Content */}
          <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg shadow-lg w-[400px] p-3">
            {/* Dialog Header */}
            <div className="flex justify-between items-center">
              <Dialog.Title className="text-lg font-semibold text-gray-900">
                You’re about to leave your interview
              </Dialog.Title>
              <Dialog.Close asChild>
                <button className="text-gray-400 hover:text-gray-600">
                  <X size={20} />
                </button>
              </Dialog.Close>
            </div>
            <hr className="-mx-3 border-gray-300 my-2" />
            {/* Dialog Description */}
            <Dialog.Description className="mt-4 text-gray-700 text-center">
              If you leave now, you won’t be able to return. Only end the
              session if you’ve been instructed that the interview has finished.
            </Dialog.Description>

            {/* Buttons */}
            <div className="mt-6 flex justify-center space-x-4">
              <Dialog.Close asChild>
                <button
                  className="px-4 py-2 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-100"
                  onClick={() => props?.setOpen(false)}
                >
                  Cancel
                </button>
              </Dialog.Close>
              <button
                className="px-4 py-2 text-white bg-red-500 rounded-md"
                onClick={props?.handleConfirm}
              >
                End Session
              </button>
            </div>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </>
  );
}
